import $ from 'jquery'

let fn = {
	initUpload(dom, opt) {
		let def = {
			'width': 80,
	        'height': 30,
	        'buttonText' : '上传',
	        'auto': true,
	        'multi':false,
	        'fileType': '.txt,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.pdf,.mp3',
	        'fileTypeExts':'',
	        'fileTypeDesc':'',
	        'queueSizeLimit' : 1,
	        'fileSizeLimit' : 50000,
	        'removeCompleted' : true,
		}
		dom.uploadifive($.extend(def, opt||{}));
	},
}

let commTools = fn;
export { commTools }


// WEBPACK FOOTER //
// ./src/service/commTools.js